import ProjectDisplay from '../components/ProjectDisplay.js';

function PosMapper() {
  const projectData = {
    name: 'POS Mapper',
    tagline: 'Point Of Sale Menu Item Mapper',
    status: 'Complete',
    version: 'v1.0.0',
    tech: ['Python', 'Next.js', 'Ollama', 'HuggingFace', 'PyTorch', 'FastAPI'],
    overview:
      'An agentic LLM that can read menu items received from Point of Sale systems, accurately gauge user intent, and map new menu items to existing menus across multiple concepts and locations.',
    features: [
      'Agentic Capabilities',
      'Custom AI toolkit',
      'Dashboard/Chat interface',
    ],
    links: {
      live: 'https://ticketshark.app',
      github: '[Private]',
    },
  };

  return <ProjectDisplay projectData={projectData} />;
}

export default PosMapper;